import { useEffect } from "react";

/**
 * SEO Component - Dynamically updates page title, meta description, and keywords
 * for each route to improve search engine optimization.
 *
 * @param {string} title - Page title
 * @param {string} description - Meta description for the page
 * @param {string} keywords - Comma-separated SEO keywords
 * @param {string} canonicalPath - Path segment for canonical URL (e.g. "/about")
 */
function SEO({ title, description, keywords, canonicalPath = "/" }) {
  useEffect(() => {
    // Update page title
    document.title = title;

    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    } else {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      metaDescription.content = description;
      document.head.appendChild(metaDescription);
    }

    // Update or create meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", keywords);
    } else {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      metaKeywords.content = keywords;
      document.head.appendChild(metaKeywords);
    }

    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    const baseUrl = "https://www.sipabacusmalkajgiri.com";
    if (canonicalLink) {
      canonicalLink.setAttribute("href", `${baseUrl}${canonicalPath}`);
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", title);

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute("content", description);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute("content", `${baseUrl}${canonicalPath}`);

    // Update Twitter Card tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute("content", title);

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) twitterDescription.setAttribute("content", description);
  }, [title, description, keywords, canonicalPath]);

  return null; // This component doesn't render anything
}

export default SEO;
